import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { isValidLanguage } from '../../utils/validation';
import ErrorPage from '../../../pages/404Page';

const LanguageValidator = ({ children, hideHeaderFooterSetter }) => {
  const { lang } = useParams();

  const validatedContent = useMemo(() => {
    
    if (window.location.pathname.startsWith('/blog')) {
      return children;
    }
    
    const knownRoutes = ['blog', 'about', 'contact', 'work', 'careers', 'sitemap'];
    if (knownRoutes.includes(lang)) {
      return children;
    }
    
    if (lang && !isValidLanguage(lang)) {
      return (
        <ErrorPage
          key="not-found-404" 
          hideHeaderFooterSetter={hideHeaderFooterSetter} 
        />
      );
    }
    return children;
  }, [lang, children, hideHeaderFooterSetter]);

  return validatedContent;
};

export default React.memo(LanguageValidator);